import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { InboxEntityType } from '@/../../shared/types/inboxTypes';

interface InboxMessageResponse {
  message: string;
}

interface InboxMessageError {
  error: string;
}

export const useInboxMessageMutation = () => {
  const markInboxMessageAsSeenMutation = useMutation<
    InboxMessageResponse,
    InboxMessageError,
    { entityType: InboxEntityType; entityId: string }
  >({
    mutationFn: async ({ entityType, entityId }) => {
      const res = await axios.post('/api/inbox/markInboxMessageAsSeen', {
        entityType,
        entityId,
      });
      return res.data;
    },
  });

  return {
    markInboxMessageAsSeenMutation,
  };
};
